import { Tooltip } from "antd";
import isToday from "dayjs/plugin/isToday";
import classNames from "classnames";
import weekday from "dayjs/plugin/weekday";
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import { CalendarTooltipContent } from "../CalendarTooltipContent";
import styles from "./styles.module.scss";

dayjs.extend(isToday);
dayjs.extend(weekday);

const isWeekend = (date: Dayjs): boolean => {
  return date.weekday() === 0 || date.weekday() === 6;
};

export const Cell = (date: Dayjs) => {
  return (
    <Tooltip
      overlayClassName={styles.tooltip}
      title={<CalendarTooltipContent title="Irina Tarasova’s Birthday Party" />}
      arrow={true}
    >
      <div className={classNames(styles.cell)}>
        <span
          className={classNames(styles.content, {
            [styles.today]: date.isToday(),
            [styles.weekend]: isWeekend(date),
            // [styles.notice]: notice,
          })}
        >
          {date.date()}
        </span>
      </div>
    </Tooltip>
  );
};
